<h3 class="title-divider">{{ heading | translate }}</h3>
<fieldset [disabled]="disabled" capAtLeastOneValidator ngModelGroup="EingabeMussMindestensEineRechteArtAusgewaehltHaben">
  <cap-form-control labelKey="Dienstbarkeit">
    <input
      (ngModelChange)="model && (model.sucheDienstbarkeit = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.sucheDienstbarkeit"
      name="AuftragRechteSelection.sucheDienstbarkeit"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="Vormerkung">
    <input
      (ngModelChange)="model && (model.sucheVormerkung = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.sucheVormerkung"
      name="AuftragRechteSelection.sucheVormerkung"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="Grundlast">
    <input
      (ngModelChange)="model && (model.sucheGrundlast = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.sucheGrundlast"
      name="AuftragRechteSelection.sucheGrundlast"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="Anmerkung">
    <input
      (ngModelChange)="model && (model.sucheAnmerkung = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.sucheAnmerkung"
      name="AuftragRechteSelection.sucheAnmerkung"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="SelbstständigesUndDauerndesRecht">
    <input
      (ngModelChange)="model && (model.sucheSDR = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.sucheSDR"
      name="AuftragRechteSelection.sucheSDR"
      type="checkbox" />
  </cap-form-control>
</fieldset>
<cap-auftrag-code-selection [(ngModel)]="model" [disabled]="disabled" [types]="types" name="AuftragRechteSelection.codeGlaeubiger">
</cap-auftrag-code-selection>
